<po-page-default>
  <div class="dashboard">

    <!-- ── Hero Section ── -->
    <section class="hero">
      <div class="hero-content">
        <p class="hero-greeting">Seja bem-vindo(a)</p>
        <h1 class="hero-name">{{userName}}</h1>
        <p class="hero-tagline">
          <span class="an an-scales hero-tagline-icon"></span>
          Consultoria Empresarial &bull; Advocacia Tributária
        </p>
      </div>
      <div class="hero-visual">
        <img src="assets/images/dash.svg" alt="Dashboard" class="hero-img" />
      </div>
    </section>

    <!-- ── Stats ── -->
    <section class="stats-row">
      <div class="stat-card" (click)="redirect('/clientes')">
        <div class="stat-icon"><i class="an an-users-three"></i></div>
        <div class="stat-body">
          <span class="stat-label">Clientes</span>
          <span class="stat-hint">Gerenciar base de clientes</span>
        </div>
        <i class="an an-caret-right stat-arrow"></i>
      </div>

      <div class="stat-card" (click)="redirect('/processos')">
        <div class="stat-icon accent-green"><i class="an an-folder-open"></i></div>
        <div class="stat-body">
          <span class="stat-label">Processos</span>
          <span class="stat-hint">Acompanhar processos ativos</span>
        </div>
        <i class="an an-caret-right stat-arrow"></i>
      </div>

      <div class="stat-card" (click)="redirect('/processamento-fichas')">
        <div class="stat-icon accent-amber"><i class="an an-file-text"></i></div>
        <div class="stat-body">
          <span class="stat-label">Fichas</span>
          <span class="stat-hint">Processamento de fichas</span>
        </div>
        <i class="an an-caret-right stat-arrow"></i>
      </div>

      <div class="stat-card" (click)="redirect('/comparacao-arquivos')">
        <div class="stat-icon accent-purple"><i class="an an-files"></i></div>
        <div class="stat-body">
          <span class="stat-label">Comparação</span>
          <span class="stat-hint">Comparar arquivos</span>
        </div>
        <i class="an an-caret-right stat-arrow"></i>
      </div>
    </section>

    <!-- ── Quick Actions ── -->
    <section class="section-block">
      <h2 class="section-title">
        <i class="an an-lightning"></i>
        Ações Rápidas
      </h2>

      <div class="actions-grid">
        <div class="action-card" (click)="redirect('/clientes-edit')">
          <div class="action-icon">
            <i class="an an-plus-circle"></i>
          </div>
          <div class="action-body">
            <h3>Novo Cliente</h3>
            <p>Cadastrar novo cliente na base</p>
          </div>
          <span class="action-go">
            Prosseguir <i class="an an-arrow-circle-right"></i>
          </span>
        </div>

        <div class="action-card" (click)="redirect('/importacoes/carga-inicial')">
          <div class="action-icon green">
            <i class="an an-upload-simple"></i>
          </div>
          <div class="action-body">
            <h3>Carga Inicial</h3>
            <p>Importar arquivos de carga inicial</p>
          </div>
          <span class="action-go">
            Prosseguir <i class="an an-arrow-circle-right"></i>
          </span>
        </div>

        <div class="action-card" (click)="redirect('/importacoes/movimentacao')">
          <div class="action-icon amber">
            <i class="an an-upload-simple"></i>
          </div>
          <div class="action-body">
            <h3>Movimentação</h3>
            <p>Importar dados de movimentações</p>
          </div>
          <span class="action-go">
            Prosseguir <i class="an an-arrow-circle-right"></i>
          </span>
        </div>

        <div class="action-card" (click)="redirect('/processamento-fichas/novo')">
          <div class="action-icon purple">
            <i class="an an-notepad"></i>
          </div>
          <div class="action-body">
            <h3>Nova Ficha</h3>
            <p>Iniciar processamento de fichas</p>
          </div>
          <span class="action-go">
            Prosseguir <i class="an an-arrow-circle-right"></i>
          </span>
        </div>
      </div>
    </section>

    <!-- ── Modules ── -->
    <section class="section-block">
      <h2 class="section-title">
        <i class="an an-squares-four"></i>
        Módulos do Sistema
      </h2>

      <div class="modules-grid">
        <div class="module-card" (click)="redirect('/notas-fiscais')">
          <i class="an an-receipt module-icon"></i>
          <span>Notas Fiscais</span>
        </div>
        <div class="module-card" (click)="redirect('/produtos')">
          <i class="an an-package module-icon"></i>
          <span>Produtos</span>
        </div>
        <div class="module-card" (click)="redirect('/participantes')">
          <i class="an an-identification-card module-icon"></i>
          <span>Participantes</span>
        </div>
        <div class="module-card" (click)="redirect('/enquadramento-legal')">
          <i class="an an-scales module-icon"></i>
          <span>Enquadramento</span>
        </div>
        <div class="module-card" (click)="redirect('/mascaras')">
          <i class="an an-barcode module-icon"></i>
          <span>Máscaras</span>
        </div>
        <div class="module-card" (click)="redirect('/usuarios')">
          <i class="an an-user-circle-gear module-icon"></i>
          <span>Usuários</span>
        </div>
      </div>
    </section>

  </div>
</po-page-default>
